import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate} from 'react-router-dom';

const options = [{
        'key': '家電',
        'value': '家電',
        'src': './img/elect.png'
    },{
        'key': '美容・健康',
        'value': '美容・健康',
        'src': './img/beauty.png'
    },{
        'key': '体験 (旅行・テーマパークなど)',
        'value': '体験 (旅行・テーマパークなど)',
        'src': './img/exercise.png'
    },{
        'key': 'グルメ',
        'value': 'グルメ',
        'src': './img/gourmet.png'
    }];

function Category(){
    const [selectedOption, setSelectedOption] = useState(null);
    const [isVoted, setIsVoted] = useState(false);
    const [userId, setUserId] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const navigate = useNavigate();
    const [isInit, setIsInit] = useState(false);

    useEffect(() => {
        setIsVoted(localStorage.getItem('isVoted') === 'true');
        if(localStorage.getItem('isVoted') !== 'true'){
            setIsInit(true);
        }
    }, []);

    const moveVote = (option) => {
        setSelectedOption(option);
        navigate('../vote/'+option.key);
    }

    const reset = () => {
        localStorage.setItem('isVoted', false);
        localStorage.setItem('category', null);
        localStorage.setItem('option', null);
        setIsVoted(false);
    }

    const ok = () => {
        navigate('../results');
    }

    const backToSelectCategory = () => {
        navigate('../category');
    }

    const goToResult = () => {
        navigate('../results');
    }

    const close = () => {
        setIsInit(false);
    }

    return (
        <div className='main'>
            <div className='header-div'>
                <img src='./img/header-removebg-preview.png'></img>
            </div>
            <div className='body-div'>
                <div className='base'>
                    <div style={{display: 'flex', justifyContent: 'right'}}>
                        <div className='go-to-button'><p onClick={() => goToResult()}>投票状況</p></div>
                    </div>
                    <p>景品カテゴリ選択</p>
                    <div>
                        {options.map((option) => (
                            // <div className='option-area' style={{'backgroundColor': option.color}} key={option.key} onClick={() => popup(option)}>
                            <div className='list-category' key={option.key} onClick={() => moveVote(option)}>
                                <img src={option.src} width={100} height={100}></img>
                                <p>{option.value}</p>
                            </div>
                        ))}
                    </div>
                </div>
            {/* {isVoted
            && 
                <div className='dialog'>
                    <p>すでに投票済みです</p>
                    <div className='button-div'>
                    <button onClick={() => reset()}>リセット</button>
                    <button className='submit-button' onClick={() => ok()}>投票内容を確認する</button>
                        </div>
                </div>
            } */}
                    {isInit
                    &&
                    <div className='curtain'></div>
                    }
                    {isInit
                    &&
                    <div className='dialog' onClick={e => e.stopPropagation()}>
                        {/* <button className='close' onClick={() => cancel()}>
                            <span className='material-symbols-outlined'></span>
                        </button> */}
                        <p className='message'>ルール説明</p>
                        <ul style={{marginLeft: '-20px'}}>
                            <li style={{marginLeft: '-2px'}}>全ジャンルの中で1品のみ応募が可能です</li>
                            <li style={{marginLeft: '-2px'}}>応募後、応募状況が確認できます</li>
                            <li style={{marginLeft: '-2px'}}>20:15までは何度でも応募賞品の変更が可能です</li>
                        </ul>
                        <div className='button-div' style={{justifyContent: 'center'}}>
                        <button onClick={() => close()}>閉じる</button>
                        </div>
                    </div>
                    }

                    {/* <button onClick={() => reset()}>リセット</button> */}
        </div>
        </div>
    );
}

export default Category;